import { useEffect, useRef, useState } from 'react';

const differentials = [
  {
    icon: 'ri-heart-2-line',
    title: 'Atendimento Humanizado',
    desc: 'Empatia e suporte real em cada etapa.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Clareza e Transparência',
    desc: 'Você entende tudo, em linguagem acessível.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Estratégia Personalizada',
    desc: 'Abordagem construída para a sua realidade.',
  },
  {
    icon: 'ri-lock-2-line',
    title: 'Sigilo Absoluto',
    desc: 'Total discrição com informações pessoais.',
  },
  {
    icon: 'ri-timer-line',
    title: 'Agilidade e Eficiência',
    desc: 'Soluções conduzidas com diligência e foco.',
  },
  {
    icon: 'ri-award-line',
    title: 'Segurança Jurídica',
    desc: 'Conhecimento sólido e ética profissional.',
  },
];

export default function Differentials() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="diferenciais" ref={ref} className="py-24 bg-ink-black relative overflow-hidden">
      <div className="absolute top-0 right-0 w-64 h-64 bg-oxford-navy/30 rounded-full -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-chestnut/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="h-px w-10 bg-burnt-peach"></div>
            <span className="text-burnt-peach text-xs tracking-[0.2em] uppercase font-sans font-medium">Por que nos escolher</span>
            <div className="h-px w-10 bg-burnt-peach"></div>
          </div>
          <h2 className="font-serif text-white text-3xl md:text-4xl font-semibold mb-4">
            O que torna meu atendimento único
          </h2>
          <p className="text-white/55 font-sans max-w-xl mx-auto text-base">
            Mais do que assessoria jurídica — um acompanhamento humano, ético e comprometido.
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {differentials.map((diff, idx) => (
            <div
              key={diff.title}
              className={`bg-white/5 hover:bg-white/8 border border-white/10 rounded-xl p-6 transition-all duration-300 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="flex items-center gap-3 mb-2">
                <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-burnt-peach/15 text-burnt-peach flex-shrink-0">
                  <i className={`${diff.icon} text-lg`}></i>
                </div>
                <h3 className="font-serif text-white text-base font-semibold">{diff.title}</h3>
              </div>
              <p className="text-white/55 font-sans text-sm leading-relaxed pl-12">{diff.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
